/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import Device from '@ion/core/src/services/Device';
import {ToolAssetType} from '@ion/core/src/types/entities';
import {getDistanceInUserUnits} from '@ion/core/src/units/helpers';
import {BreadcrumbActions} from '@ion/dls/src/types/types';
import {BreadcrumbsType, SidesheetPages} from '@/types/sidesheet';

export const initialCrumb = {} as BreadcrumbsType;

export const getAssetBreadCrumb = (device: Device): BreadcrumbsType | null => {
  const assetName = device?.getAssetName();
  return device ? {
    label  : assetName ?? device.name(), // priortize assetName if exists, otherwise go by device name.
    click  : BreadcrumbActions.backClick,
    source : SidesheetPages.DETAIL
  }: null;
};

export const getToolCrumb = (selectedTool: ToolAssetType): BreadcrumbsType | null => {
  return selectedTool ? {
    label  : selectedTool.name,
    click  : undefined,
    source : SidesheetPages.ASSOCIATED_TAG
  } : null;
};

export const getNearByCrumb = (findNearby, hasSelectedAsset = false): BreadcrumbsType | null => {
  return findNearby.isActive ? {
    label  : `${findNearby.label} - ${getDistanceInUserUnits(findNearby.miles, 'tracking:breadcrumb')}`,
    click  : undefined,
    source : hasSelectedAsset ? SidesheetPages.DETAIL_FIND_NEARBY : SidesheetPages.FIND_NEARBY
  }: null;
};
